/* Auren Studio US — small shared behaviors (no dependencies).
   1. Reveal on scroll (progressive enhancement, respects reduced motion)
   2. Scroller prev/next buttons
   3. Poster-first UGC video cards (one plays at a time)
   4. Muted in-view autoplay for feature videos */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* 1. Reveal */
  var revealIO = hasIO && !reduce && !(window.Shopify && window.Shopify.designMode)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          revealIO.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  function initReveal(scope) {
    if (!revealIO) return;
    var vh = window.innerHeight;
    scope.querySelectorAll('[data-au-reveal]:not(.is-revealed):not([data-au-watch])').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) {
        el.classList.add('is-revealed');
      } else {
        el.setAttribute('data-au-watch', '');
        revealIO.observe(el);
      }
    });
    document.documentElement.classList.add('au-reveal-ready');
  }

  /* 2 + 3. Scrollers and UGC cards */
  function initScrollers(scope) {
    scope.querySelectorAll('[data-au-ugc]:not([data-au-ready])').forEach(function (root) {
      root.setAttribute('data-au-ready', '');
      var track = root.querySelector('[data-au-track]');
      if (!track) return;
      function step(dir) {
        var card = track.firstElementChild;
        if (!card) return;
        track.scrollBy({ left: dir * (card.getBoundingClientRect().width + 14), behavior: reduce ? 'auto' : 'smooth' });
      }
      var prev = root.querySelector('[data-au-prev]');
      var next = root.querySelector('[data-au-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      root.querySelectorAll('[data-au-play]').forEach(function (btn) {
        var card = btn.closest('.au-ugc__card');
        var video = card.querySelector('video');
        btn.addEventListener('click', function () {
          ensureSrc(video);
          video.muted = false;
          var p = video.play();
          if (p && p.catch) p.catch(function () { video.muted = true; video.play(); });
          card.classList.add('is-playing', 'has-sound');
        });
        video.addEventListener('click', function () {
          if (video.muted) {
            video.muted = false;
            card.classList.add('has-sound');
          } else {
            video.muted = true;
            card.classList.remove('has-sound');
          }
        });
      });
    });
  }

  function ensureSrc(video) {
    if (!video.getAttribute('src') && video.dataset.src) video.setAttribute('src', video.dataset.src);
  }

  /* 3b. Viewport-aware muted autoplay for review/UGC videos.
     Plays only what is meaningfully visible (max 2 at once), pauses when it leaves. */
  var saveData = navigator.connection && navigator.connection.saveData;
  var ugcRatios = new Map();
  var MAX_PLAYING = 2;
  var ugcIO = hasIO && !reduce && !saveData
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ugcRatios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0); });
        if (document.documentElement.classList.contains('au-story-open')) return;
        var visible = Array.from(ugcRatios.entries())
          .filter(function (kv) { return kv[1] >= 0.6; })
          .sort(function (a, b) { return b[1] - a[1]; })
          .slice(0, MAX_PLAYING)
          .map(function (kv) { return kv[0]; });
        ugcRatios.forEach(function (ratio, video) {
          var card = video.closest('.au-ugc__card, .mavryn-ugc-card');
          if (visible.indexOf(video) !== -1) {
            ensureSrc(video);
            if (!card || !card.classList.contains('has-sound')) video.muted = true;
            video.loop = true;
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
            if (card) card.classList.add('is-playing');
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: [0, 0.3, 0.6, 0.9] })
    : null;

  function initUgcAutoplay(scope) {
    if (!ugcIO) return;
    scope.querySelectorAll('.au-ugc__video:not([data-au-auto]), .mavryn-ugc-card__video:not([data-au-auto])').forEach(function (v) {
      v.setAttribute('data-au-auto', '');
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      ugcIO.observe(v);
    });
  }

  /* 4. Feature videos: play muted only while visible */
  var videoIO = hasIO
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && !reduce) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 })
    : null;

  function initVideos(scope) {
    if (!videoIO) return;
    scope.querySelectorAll('video[data-au-autoplay]:not([data-au-bound])').forEach(function (v) {
      v.setAttribute('data-au-bound', '');
      videoIO.observe(v);
    });
  }

  /* 5. "Shop" links on product pages land at the start of the shopping area (product gallery). */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href="#auren-buy"]');
    if (!link) return;
    var target =
      document.querySelector('.product-information media-gallery') ||
      document.querySelector('[id^="ProductInformation-"], .product-information');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* 6. MoonBundle drawer copy: "You're $X from a Free shipping" -> "You're $X away from free shipping".
     Edits only the static words; the dynamic amount and all cart logic stay with MoonBundle. */
  function fixCartCopy(root) {
    root.querySelectorAll('.moonbundle-cart-progress-bar-initial-text').forEach(function (el) {
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && /\bfrom a\s*$/.test(n.data)) {
          n.data = n.data.replace(/\bfrom a(\s*)$/, 'away from$1');
        } else if (n.nodeType === 1 && n.tagName === 'STRONG' && n.firstChild && n.firstChild.nodeType === 3 && n.firstChild.data.trim() === 'Free shipping') {
          n.firstChild.data = n.firstChild.data.replace('Free shipping', 'free shipping');
        }
      });
    });
  }

  function watchCart() {
    var drawer = document.querySelector('.moonbundle-cart-drawer');
    if (!drawer || drawer.hasAttribute('data-au-watch')) return !!drawer;
    drawer.setAttribute('data-au-watch', '');
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fixCartCopy(drawer); });
    }).observe(drawer, { childList: true, subtree: true, characterData: true });
    fixCartCopy(drawer);
    return true;
  }

  function initCart() {
    if (watchCart()) return;
    var bodyObserver = new MutationObserver(function () {
      if (watchCart()) bodyObserver.disconnect();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* 7. Customer video stories: circular bubbles open a vertical story modal.
     Video loads only on tap; closing restores the exact scroll position. */
  var story = null;

  function storyScrollEl() {
    var pw = document.querySelector('.page-wrapper');
    return pw && pw.scrollHeight > pw.clientHeight + 1 && getComputedStyle(pw).overflowY !== 'visible' ? pw : null;
  }

  function buildStory() {
    var d = document.createElement('dialog');
    d.className = 'au-story';
    d.setAttribute('aria-label', 'Customer video');
    d.innerHTML =
      '<div class="au-story__frame">' +
        '<div class="au-story__bars" aria-hidden="true"></div>' +
        '<video playsinline preload="none" loop></video>' +
        '<button type="button" class="au-story__btn au-story__mute" aria-label="Mute sound"></button>' +
        '<button type="button" class="au-story__btn au-story__close" aria-label="Close video"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<button type="button" class="au-story__btn au-story__prev" aria-label="Previous video"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M15 6l-6 6 6 6"/></svg></button>' +
        '<button type="button" class="au-story__btn au-story__next" aria-label="Next video"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg></button>' +
        '<p class="au-story__label"></p>' +
      '</div>';
    document.body.appendChild(d);
    var s = {
      dialog: d,
      frame: d.querySelector('.au-story__frame'),
      video: d.querySelector('video'),
      bars: d.querySelector('.au-story__bars'),
      label: d.querySelector('.au-story__label'),
      mute: d.querySelector('.au-story__mute'),
      prev: d.querySelector('.au-story__prev'),
      next: d.querySelector('.au-story__next'),
      items: [], index: 0, scrollY: 0, pwTop: 0, muted: false
    };
    var ICON_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 010 7"/></svg>';
    var ICON_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M22 9l-6 6M16 9l6 6"/></svg>';
    s.renderMute = function () {
      s.mute.innerHTML = s.video.muted ? ICON_OFF : ICON_ON;
      s.mute.setAttribute('aria-label', s.video.muted ? 'Turn sound on' : 'Mute sound');
    };
    s.mute.addEventListener('click', function () { s.video.muted = !s.video.muted; s.muted = s.video.muted; s.renderMute(); });
    s.video.addEventListener('volumechange', s.renderMute);
    d.querySelector('.au-story__close').addEventListener('click', closeStory);
    s.prev.addEventListener('click', function () { showStory(s.index - 1); });
    s.next.addEventListener('click', function () { showStory(s.index + 1); });
    d.addEventListener('cancel', function (e) { e.preventDefault(); closeStory(); });
    d.addEventListener('click', function (e) { if (e.target === d) closeStory(); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') showStory(s.index + 1);
      if (e.key === 'ArrowLeft') showStory(s.index - 1);
    });
    return s;
  }

  function showStory(i) {
    var s = story;
    if (i < 0 || i >= s.items.length) return;
    s.index = i;
    var item = s.items[i];
    s.video.pause();
    s.frame.style.backgroundImage = 'url("' + item.poster + '")';
    s.video.setAttribute('poster', item.poster);
    s.video.src = item.src;
    s.video.muted = s.muted;
    s.label.textContent = item.label;
    s.bars.innerHTML = s.items.map(function (_, n) { return '<span' + (n === i ? ' class="is-active"' : '') + '></span>'; }).join('');
    s.prev.hidden = i === 0;
    s.next.hidden = i === s.items.length - 1;
    var p = s.video.play();
    if (p && p.catch) p.catch(function () { s.video.muted = true; s.muted = true; s.video.play().catch(function () {}); });
    s.renderMute();
  }

  function openStory(button) {
    if (!story) story = buildStory();
    var root = button.closest('[data-au-stories]');
    story.items = Array.prototype.map.call(root.querySelectorAll('.au-story-bubble'), function (b) {
      return { src: b.dataset.src, poster: b.dataset.poster, label: b.dataset.label };
    });
    // Remember the exact position (window on mobile, .page-wrapper on desktop).
    var pw = storyScrollEl();
    story.scrollY = window.pageYOffset;
    story.pwTop = pw ? pw.scrollTop : 0;
    story.muted = false;
    document.querySelectorAll('video').forEach(function (v) { if (v !== story.video) v.pause(); });
    document.documentElement.classList.add('au-story-open');
    story.dialog.showModal();
    showStory(Number(button.dataset.auStory) || 0);
  }

  function closeStory() {
    var s = story;
    if (!s || !s.dialog.open) return;
    s.video.pause();
    s.video.removeAttribute('src');
    s.video.load();
    s.dialog.close();
    document.documentElement.classList.remove('au-story-open');
    var pw = storyScrollEl();
    if (pw) pw.scrollTop = s.pwTop;
    window.scrollTo({ top: s.scrollY, behavior: 'instant' });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.au-story-bubble');
    if (!b) return;
    e.preventDefault();
    openStory(b);
  });

  function init(scope) {
    scope = scope || document;
    initReveal(scope);
    initScrollers(scope);
    initVideos(scope);
    initUgcAutoplay(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); initCart(); });
  } else {
    init(document);
    initCart();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
